const tags = {
  AR: 'ar',
  NW: 'nw',
  PG: 'pg3',
  TL: 'tl',
  GM: 'gm',
};

const getTagValue = (label) => {
  return tags[label];
};

const getTagLabel = (value) => {
  return Object.keys(tags).find(v => tags[v] === value);
};

export { tags, getTagValue, getTagLabel };
